import ColumnFilterPanel from "../filters/ColumnFilterPanel";
import { Popover } from "@mui/material";
import { reportsV3FilterPanelWidthPx } from "config";
import React from "react";

// The pre-aggregation filter panel in its popover, driven by the panelProps
// that usePreAggFilters returns.
const PreAggFilterPopover = ({ panelProps }) => (
  <Popover
    open={Boolean(panelProps.anchorEl)}
    anchorEl={panelProps.anchorEl}
    onClose={panelProps.onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
    slotProps={{
      paper: {
        sx: {
          width: reportsV3FilterPanelWidthPx(),
          display: "flex",
          flexDirection: "column",
        },
      },
    }}
  >
    <ColumnFilterPanel {...panelProps.panel} />
  </Popover>
);

export default PreAggFilterPopover;
